module.exports = __webpack_public_path__ + "img/37.6.CODm.8e75117c.png";